import mutations, { initialState } from './mutations';
import getters from './getters';

/**
 * Estado do chat de suporte embutido (DeepDesk).
 *
 * O painel vive em App.vue, fora do <Menu>, e e ele quem conversa com o iframe.
 * Aqui fica so o que o resto do app precisa enxergar ou pedir: se o chat esta
 * disponivel, se esta aberto, o selo, a bolinha e o pedido de abrir ou fechar
 * vindo do menu.
 */
export const OPTIONS_STORE_SUPPORT_WIDGET = {
  MUTATIONS: {
    SET_SNAPSHOT: 'supportWidget/setSnapshot',
    SET_SUMMONED: 'supportWidget/setSummoned',
    REQUEST_OPEN: 'supportWidget/requestOpen',
    REQUEST_CLOSE: 'supportWidget/requestClose',
    RESET: 'supportWidget/reset'
  },
  GETTERS: {
    IS_AVAILABLE: 'supportWidget/isAvailable',
    IS_OPEN: 'supportWidget/isOpen',
    UNREAD: 'supportWidget/unread',
    ATTENTION: 'supportWidget/attention',
    PENDING: 'supportWidget/pending',
    IS_LAUNCHER_VISIBLE: 'supportWidget/isLauncherVisible',
    REQUEST: 'supportWidget/request'
  }
};

export default {
  state: initialState,
  getters,
  mutations,
  namespaced: true
};
